import { useState, useEffect } from 'react';

export type TimeOfDay = 'morning' | 'afternoon' | 'evening' | 'night';

function getTimeOfDay(hour: number): TimeOfDay {
  if (hour >= 5 && hour < 12) return 'morning';
  if (hour >= 12 && hour < 17) return 'afternoon';
  if (hour >= 17 && hour < 21) return 'evening';
  return 'night';
}

function getGreeting(timeOfDay: TimeOfDay): string {
  switch (timeOfDay) {
    case 'morning': return 'Good morning';
    case 'afternoon': return 'Good afternoon';
    case 'evening': return 'Good evening';
    case 'night': return 'Good evening';
  }
}

interface TimeAwareResult {
  timeOfDay: TimeOfDay;
  greeting: string;
}

/**
 * Returns a time-aware greeting and time-of-day label.
 * Optionally accepts an override for Storybook controls.
 */
export function useTimeAwareImage(override?: TimeOfDay): TimeAwareResult {
  const [timeOfDay, setTimeOfDay] = useState<TimeOfDay>(
    override ?? getTimeOfDay(new Date().getHours()),
  );

  useEffect(() => {
    if (override) {
      setTimeOfDay(override);
      return;
    }
    // Update every minute in case the time-of-day boundary passes
    const interval = setInterval(() => {
      setTimeOfDay(getTimeOfDay(new Date().getHours()));
    }, 60_000);
    return () => clearInterval(interval);
  }, [override]);

  return {
    timeOfDay,
    greeting: getGreeting(timeOfDay),
  };
}
